import { CardClassKey } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const MuiCard: Record<CardClassKey, CSSProperties> = {
  root: {},
};
